export const cookieUtils = {
    // Set cookie
    setCookie: (name, value, days) => {
        const expires = new Date();
        expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
        document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/;secure;samesite=strict`;
    },

    // Get cookie
    getCookie: (name) => {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
        return null;
    },

    // Delete cookie
    deleteCookie: (name) => {
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
    },

    // Get access token from cookie
    getAccessToken: () => {
        return cookieUtils.getCookie('accessToken');
    },

    // Get refresh token from cookie
    getRefreshToken: () => {
        return cookieUtils.getCookie('refreshToken');
    },

    // Clear all auth cookies
    clearAuthCookies: () => {
        cookieUtils.deleteCookie('accessToken');
        cookieUtils.deleteCookie('refreshToken');
        localStorage.removeItem('user');
    }
};